import { type Locale, siteNames } from '@seek/melways-sites';
import get from 'lodash.get';

import { noop } from '../components/type';
import { type EmployerSiteNames, environments } from '../siteConfig';

interface WindowConfig {
  environment: string;
  site: EmployerSiteNames;
  language: Locale;
  localAuth?: boolean;
  version?: string;
  branch?: string;
}

export const defaultWindowConfig: WindowConfig = {
  environment: environments.development,
  site: siteNames.employer.seek.au,
  language: 'en-AU',
};

declare global {
  interface Window {
    config?: WindowConfig;
    currentPageTrackingData?: any;
    Intercom?: (
      action: string,
      value?: Record<string, unknown> | string,
    ) => undefined;
    hj: any;
    currentSystemUser: number;
    SEEK_TEST?: boolean;
  }
}

export const getWindowObject = (path: string, defaultValue: any) => {
  if (typeof window === 'undefined' || window === null) {
    return defaultValue;
  }

  return get(window, path, defaultValue);
};

export const getWindow = (): Window | null =>
  typeof window !== 'undefined' ? window : null;

export const getWindowLocation = ():
  | Location
  | { href: string; origin: string; pathname: string; search: string } =>
  getWindowObject('location', {
    href: '',
    origin: '',
    pathname: '',
    search: '',
  });

export const getWindowLocationSearch = () =>
  getWindowObject('location.search', '');

export const getWindowConfig = () => getWindowObject('config', {});

export const getWindowOpen = () => getWindowObject('open', noop);

export const navigateToPage = (url: string) => {
  const win = getWindow();
  if (!win) {
    throw new Error('no window object');
  }
  win.location.assign(url);
};
